

// import axios from 'axios';
// import React from 'react';
// import { Link, useHistory } from 'react-router-dom';
// import { BsPlus } from 'react-icons/bs';
// import '../Components/Component-css/Header.css';
// import css from './Component-css/Nav.module.css';
// import { MdOutlineLogout, MdChevronRight } from 'react-icons/md';

// const w3_close = () => {
//   const sidebar = document.getElementById('mySidebar');
//   if (!sidebar) return;
//   sidebar.style.transform = 'translateX(-100%)';
//   document.getElementById('sidebarOverlay').style.opacity = '0';
//   setTimeout(() => {
//     document.getElementById('sidebarOverlay').style.display = 'none';
//   }, 300);
// };

// const w3_open = () => {
//   const sidebar = document.getElementById('mySidebar');
//   if (!sidebar) return;
//   sidebar.style.display = 'block';
//   setTimeout(() => {
//     sidebar.style.transform = 'translateX(0)';
//     document.getElementById('sidebarOverlay').style.display = 'block';
//     document.getElementById('sidebarOverlay').style.opacity = '1';
//   }, 10);
// };

// const Header = ({ user }) => {
//   const history = useHistory();
//   const access_token = localStorage.getItem('token');

//   const logout = () => {
//     const headers = { Authorization: `Bearer ${access_token}` };
//     axios
//       .post(`https://api.rrludo.in/logout`, { headers }, { headers })
//       .then(() => {
//         localStorage.removeItem('token');
//         window.location.reload();
//         history.push('/');
//       })
//       .catch(e => {
//         if (e.response?.status === 401) {
//           localStorage.removeItem('token');
//         }
//       });
//   };

//   const styles = {
//     topHeader: {
//       background: 'linear-gradient(180deg, #1a1a1a 0%, #000 100%)',
//       padding: '14px 15px',
//       position: 'fixed',
//       top: 0,
//       left: 0,
//       width: '100%',
//       zIndex: 1000,
//       borderBottom: '1px solid rgba(255,255,255,0.05)',
//       boxShadow: '0 4px 20px rgba(0,0,0,0.5)',
//       marginTop:"18px"
//     },
//     actionChip: {
//       background: 'rgba(255, 255, 255, 0.05)',
//       borderRadius: '20px',
//       padding: '4px 12px',
//       display: 'flex',
//       alignItems: 'center',
//       border: '1px solid rgb(201 42 42 / 85%)',
//       height: '38px',
//       transition: '0.3s'
//     },
//     plusIcon: {
//       background: '#FF3131',
//       borderRadius: '50%',
//       width: '20px',
//       height: '20px',
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'center',
//       marginLeft: '8px'
//     }
//   };

//   return (
//     <div style={{ marginBottom: '80px'  }}>
//       {access_token ? (
//         <>
//           {/* Overlay with Blur */}
//           <div id="sidebarOverlay" onClick={w3_close} style={{
//             position: 'fixed', display: 'none', width: '100%', height: '100%',
//             top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.8)',
//             backdropFilter: 'blur(5px)', zIndex: 1001, transition: '0.3s', opacity: 0
//           }}></div>

//           {/* Sidebar - Premium Glass Layout */}
//           <div className="w3-sidebar" id="mySidebar" style={{
//             width: '280px', background: '#121212', color: '#fff', 
//             transition: '0.4s cubic-bezier(0.4, 0, 0.2, 1)', transform: 'translateX(-100%)',
//             zIndex: 1002, borderRight: '1px solid #333', boxShadow: '10px 0 30px rgba(0,0,0,0.5)',
//             position: 'fixed', height: '100%', top: 0, left: 0
//           }}>
//             <div style={{ padding: '40px 20px', background: 'linear-gradient(180deg, #FF3131, #BA0000)' }}>
//               <div className="d-flex align-items-center">
//                 <img 
//                   src={user?.avatar ? `https://api.rrludo.in/${user?.avatar}` : `/images/avatars/Avatar2.png`} 
//                   style={{ width: '65px', height: '65px', borderRadius: '50%', border: '3px solid #fff', objectFit: 'cover' }}
//                   alt="profile"
//                 />
//                 <div className="ml-3">
//                   <h6 className="mb-0 fw-bold text-white">{user?.Name || "Player"}</h6>
//                   <small style={{ opacity: 0.9, fontSize: '11px', letterSpacing: '0.5px' }}>ID: {user?._id?.slice(-6).toUpperCase()}</small>
//                 </div>
//               </div>
//             </div>

//             <div style={{ padding: '20px 10px' }}>
//               {[
//                 { to: "/Profile", img: "/images/avatars/Avatar2.png", label: "My Profile" },
//                 { to: "/landing", img: "/images/Header/wincase.gif", label: "Win Cash" },
//                 { to: "/wallet", img: "/images/Header/wallet.gif", label: "My Wallet" },
//                 { to: "/transaction-history", img: "/images/Header/gamehistory.gif", label: "History" },
//                 { to: "/Referral-history", img: "/images/Header/referr.gif", label: "Refer History" },
//                 { to: "/refer", img: "/images/Header/refer_earn.gif", label: "Refer & Earn" },
//                 { to: "/Notification", img: "/images/Header/notification.gif", label: "Notification" },
//                 { to: "/support", img: "/images/Header/support.gif", label: "Support" },
//               ].map((item, index) => (
//                 <Link key={index} to={item.to} className="sidebar-link" onClick={w3_close} style={{
//                   display: 'flex', alignItems: 'center', padding: '12px 15px', 
//                   borderRadius: '15px', marginBottom: '5px', color: '#ccc', textDecoration: 'none'
//                 }}>
//                   <img src={item.img} width="26" height="26" alt="icon" style={{ borderRadius: '50%' }} />
//                   <span style={{ marginLeft: '15px', fontWeight: '500', fontSize: '14px', flexGrow: 1 }}>{item.label}</span>
//                   <MdChevronRight color="#444" />
//                 </Link>
//               ))}
              
//               <button onClick={logout} className="sidebar-link" style={{
//                 display: 'flex', alignItems: 'center', padding: '12px 15px', borderRadius: '15px', 
//                 background: 'rgba(255,49,49,0.1)', color: '#FF3131', border: 'none', width: '90%', margin: '20px auto 0'
//               }}>
//                 <MdOutlineLogout size={20} />
//                 <span style={{ marginLeft: '15px', fontWeight: '700' }}>Logout</span>
//               </button>
//             </div>
//           </div>

//           {/* Top Navbar */}
//           <header style={styles.topHeader}>
//             <div className="d-flex align-items-center justify-content-between">
//               <div className="d-flex align-items-center">
//                 <button style={{ background: 'none', border: 'none', padding: 0 }} onClick={w3_open}>
//                   <img src="/images/LandingPage_img/sidebar2.png" width="32" alt="menu" />
//                 </button>
//                 <Link to="/">
//                   <img src="/images/addanew.png" className="ml-3" height="38" alt="logo" />
//                 </Link>
//               </div>

//               <div className="d-flex align-items-center" style={{ gap: "10px" }}>
//                 {/* Wallet Balance */}
//                 <Link to="/Addcase" style={{ ...styles.actionChip, textDecoration: 'none' }}>
//                   <img src="/images/Wallet_Cash.gif" width="24" height="24" alt="w" />
//                   <span style={{ color: '#fff', fontSize: '14px', marginLeft: '6px', fontWeight: '800' }}>
//                     ₹{user?.Wallet_balance || 0}
//                   </span>
//                   <div style={styles.plusIcon}><BsPlus size={16} color="#fff" /></div>
//                 </Link>

//                 {/* Refer Balance */}
//                 <Link to="/redeem/refer" style={{ ...styles.actionChip, textDecoration: 'none' }}>
//                   <img src="/images/refer_gift.gif" width="24" height="24" alt="g" />
//                   <span style={{ color: '#fff', fontSize: '14px', marginLeft: '6px', fontWeight: '800' }}>
//                     ₹{user?.referral_wallet || 0}
//                   </span>
//                 </Link>
//               </div>
//             </div>
//           </header>
//         </>
//       ) : (
//         <header style={styles.topHeader}>
//           <div className="d-flex align-items-center justify-content-between">
//             <Link to="/">
//               <img src="/images/addanew.png" height="50" alt="logo" />
//             </Link>
//             <Link to="/login" style={{
//               background: 'linear-gradient(180deg, #FF3131 0%, #BA0000 100%)',
//               color: '#fff', borderRadius: '25px', padding: '8px 22px', 
//               fontSize: '13px', fontWeight: '800', textDecoration: 'none', boxShadow: '0 4px 15px rgba(186,0,0,0.4)'
//             }}>
//               LOGIN
//             </Link>
//           </div>
//         </header>
//       )}

//       {/* Global CSS for Animations */}
//       <style>{`
//         .sidebar-link:hover { background: rgba(255,255,255,0.05); color: #fff !important; }
//         .sidebar-link img { transition: 0.3s; }
//         .sidebar-link:hover img { transform: scale(1.1); }
//         #mySidebar { display: block !important; } /* Ensure it's ready for transform */
//       `}</style>
//     </div>
//   );
// };

// export default Header;


import axios from 'axios';
import React from 'react';
import { Link, useHistory } from 'react-router-dom';
import { BsPlus } from 'react-icons/bs';
import '../Components/Component-css/Header.css';
import css from './Component-css/Nav.module.css';
import { MdOutlineLogout, MdChevronRight } from 'react-icons/md';

const w3_close = () => {
  const sidebar = document.getElementById('mySidebar');
  if (!sidebar) return;
  sidebar.style.transform = 'translateX(-100%)';
  document.getElementById('sidebarOverlay').style.opacity = '0';
  setTimeout(() => {
    document.getElementById('sidebarOverlay').style.display = 'none';
  }, 300);
};

const w3_open = () => {
  const sidebar = document.getElementById('mySidebar');
  if (!sidebar) return;
  sidebar.style.display = 'block';
  setTimeout(() => {
    sidebar.style.transform = 'translateX(0)';
    document.getElementById('sidebarOverlay').style.display = 'block';
    document.getElementById('sidebarOverlay').style.opacity = '1';
  }, 10);
};

const Header = ({ user }) => {
  const history = useHistory();
  const access_token = localStorage.getItem('token');

  const logout = () => {
    const headers = { Authorization: `Bearer ${access_token}` };
    axios
      .post(`https://api.rrludo.in/logout`, { headers }, { headers })
      .then(() => {
        localStorage.removeItem('token');
        window.location.reload();
        history.push('/');
      })
      .catch(e => {
        if (e.response?.status === 401) {
          localStorage.removeItem('token');
        }
      });
  };

  const styles = {
    topHeader: {
      background: '#000000', // Solid Black Header
      padding: '20px 15px',
      position: 'fixed',
      top: 12,
      left: 0,
      width: '100%',
      zIndex: 1000,
      borderBottom: '2px solid #FF9800', // Orange Underline
      boxShadow: '0 4px 15px rgba(0,0,0,0.3)',
    },
    actionChip: {
      background: '#1a1a1a', // Dark Chip
      borderRadius: '12px',
      padding: '4px 10px',
      display: 'flex',
      alignItems: 'center',
      border: '1px solid #333',
      height: '36px',
      transition: '0.3s'
    },
    plusIcon: {
      background: '#FF9800', // Orange Plus
      borderRadius: '6px',
      width: '20px',
      height: '20px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginLeft: '8px'
    },
    balanceText: {
        color: '#FFF9C4', // Light Yellow Balance
        fontSize: '14px',
        marginLeft: '6px',
        fontWeight: '800'
    }
  };

  return (
    <div style={{ marginBottom: '75px' }}>
      {access_token ? (
        <>
          {/* Sidebar Overlay */}
          <div id="sidebarOverlay" onClick={w3_close} style={{
            position: 'fixed', display: 'none', width: '100%', height: '100%',
            top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.7)',
            backdropFilter: 'blur(3px)', zIndex: 1001, transition: '0.3s', opacity: 0
          }}></div>

          {/* Sidebar - Theme Redesign */}
          <div className="w3-sidebar" id="mySidebar" style={{
            width: '280px', background: '#FFFDE7', color: '#000', // Light Yellow Side
            transition: '0.4s cubic-bezier(0.4, 0, 0.2, 1)', transform: 'translateX(-100%)',
            zIndex: 1002, borderRight: '2px solid #FF9800',
            position: 'fixed', height: '100%', top: 0, left: 0
          }}>
            {/* Sidebar Profile Header */}
            <div style={{ padding: '40px 20px', background: '#000' }}>
              <div className="d-flex align-items-center">
                <img 
                  src={user?.avatar ? `https://api.rrludo.in/${user?.avatar}` : `/images/avatars/Avatar2.png`} 
                  style={{ width: '60px', height: '60px', borderRadius: '18px', border: '2px solid #FF9800', objectFit: 'cover' }}
                  alt="profile"
                />
                <div className="ml-3">
                  <h6 className="mb-0 fw-bold" style={{ color: '#FF9800' }}>{user?.Name || "Player"}</h6>
                  <small style={{ color: '#FFF9C4', fontSize: '10px', fontWeight: '700' }}>VERIFIED USER</small>
                </div>
              </div>
            </div>

            {/* Sidebar Navigation */}
            <div style={{ padding: '15px 10px' }}>
              {[
                { to: "/Profile", img: "/images/avatars/Avatar2.png", label: "Profile Settings" },
                { to: "/landing", img: "/images/Header/wincase.gif", label: "Play & Win" },
                { to: "/wallet", img: "/images/Header/wallet.gif", label: "Wallet Balance" },
                { to: "/transaction-history", img: "/images/Header/gamehistory.gif", label: "History" },
                { to: "/Referral-history", img: "/images/Header/referr.gif", label: "Refer History" },
                { to: "/refer", img: "/images/Header/refer_earn.gif", label: "Invite & Earn" },
                { to: "/Notification", img: "/images/Header/notification.gif", label: "Notifications" },
                { to: "/support", img: "/images/Header/support.gif", label: "Customer Care" },
              ].map((item, index) => (
                <Link key={index} to={item.to} className="sidebar-link-custom" onClick={w3_close} style={{
                  display: 'flex', alignItems: 'center', padding: '14px 15px', 
                  borderRadius: '12px', marginBottom: '4px', color: '#000', textDecoration: 'none',
                  borderBottom: '1px solid #F0E68C'
                }}>
                  <img src={item.img} width="24" height="24" alt="icon" style={{ borderRadius: '6px' }} />
                  <span style={{ marginLeft: '15px', fontWeight: '700', fontSize: '13px', flexGrow: 1 }}>{item.label}</span>
                  <MdChevronRight color="#FF9800" size={20} />
                </Link>
              ))}
              
              <button onClick={logout} style={{
                display: 'flex', alignItems: 'center', padding: '15px', borderRadius: '12px', 
                background: '#000', color: '#FF9800', border: 'none', width: '90%', margin: '25px auto 0',
                fontWeight: '800', cursor: 'pointer'
              }}>
                <MdOutlineLogout size={20} />
                <span style={{ marginLeft: '15px' }}>Logout Session</span>
              </button>
            </div>
          </div>

          {/* Top Navbar */}
          <header style={styles.topHeader}>
            <div className="d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center">
                <button style={{ background: 'none', border: 'none', padding: 0 }} onClick={w3_open}>
                  <img src="/images/LandingPage_img/sidebar.png" width="28" style={{ filter: 'invert(1)' }} alt="menu" />
                </button>
                <Link to="/">
                  <img src="/images/addanew.png" className="ml-3" height="20" alt="logo" />
                </Link>
              </div>

              <div className="d-flex align-items-center" style={{ gap: "8px" }}>
                {/* Wallet Balance */}
                <Link to="/Addcase" style={{ ...styles.actionChip, textDecoration: 'none' }}>
                  <img src="/images/Wallet_Cash.gif" width="22" height="22" alt="w" />
                  <span style={styles.balanceText}>
                    ₹{user?.Wallet_balance || 0}
                  </span>
                  <div style={styles.plusIcon}><BsPlus size={16} color="#000" /></div>
                </Link>

                {/* Refer Balance */}
                <Link to="/redeem/refer" style={{ ...styles.actionChip, textDecoration: 'none', borderColor: '#FF9800' }}>
                  <img src="/images/refer_gift.gif" width="22" height="22" alt="g" />
                  <span style={{...styles.balanceText, color: '#FF9800'}}>
                    ₹{user?.referral_wallet || 0}
                  </span>
                </Link>
              </div>
            </div>
          </header>
        </>
      ) : (
        <header style={{...styles.topHeader, padding: '15px'}}>
          <div className="d-flex align-items-center justify-content-between">
            <Link to="/">
              <img src="/images/addanew.png" height="20" alt="logo" />
            </Link>
            <Link to="/login" style={{
              background: '#FF9800',
              color: '#000', borderRadius: '8px', padding: '8px 20px', 
              fontSize: '13px', fontWeight: '900', textDecoration: 'none', boxShadow: '0 4px 10px rgba(255,152,0,0.3)'
            }}>
              LOGIN
            </Link>
          </div>
        </header>
      )}

      {/* Style Overrides */}
      <style>{`
        .sidebar-link-custom:hover { 
            background: #FF9800 !important; 
            color: #000 !important; 
        }
        .sidebar-link-custom:hover svg {
            color: #000 !important;
        }
        #mySidebar { display: block !important; }
      `}</style>
    </div>
  );
};

export default Header;
